import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface RecentState {
  recentlyViewed: string[];
  addToRecentlyViewed: (id: string) => void;
}

export const useRecentStore = create<RecentState>()(
  persist(
    (set) => ({
      recentlyViewed: [],
      addToRecentlyViewed: (id) =>
        set((state) => {
          const filtered = state.recentlyViewed.filter((item) => item !== id);
          return { recentlyViewed: [id, ...filtered].slice(0, 10) };
        }),
    }),
    {
      name: 'vivatis-recent',
      version: 1,
      migrate: (persisted, version) => {
        if (version === 0 && Array.isArray(persisted)) {
          return { recentlyViewed: persisted };
        }
        return persisted as RecentState;
      },
    },
  ),
);
